import type { TimeFormat } from '@elfsight/configurator-controls/src/';
import { parse } from 'fast-time-input';
import type { DropdownOption } from '../../_components/text-dropdown/text-dropdown';
import { removeLeadingZero } from './removeLeadingZero';

const CACHE = new Map<TimeFormat | undefined, DropdownOption[]>();

export const getTimeOptions = (timeFormatResolved: TimeFormat | undefined) => {
  if (CACHE.has(timeFormatResolved)) {
    return CACHE.get(timeFormatResolved)!;
  }

  const options = BASE_TIMES.map(({ hour, minute }, index) => {
    const raw = `${hour}:${minute}`;

    return {
      id: String(index),
      value: parse(raw, '24hr'),
      label: removeLeadingZero(parse(raw, timeFormatResolved))
    };
  });

  CACHE.set(timeFormatResolved, options);
  return options;
};

const BASE_TIMES = [
  { hour: '0', minute: '00' },
  { hour: '0', minute: '15' },
  { hour: '0', minute: '30' },
  { hour: '0', minute: '45' },
  { hour: '1', minute: '00' },
  { hour: '1', minute: '15' },
  { hour: '1', minute: '30' },
  { hour: '1', minute: '45' },
  { hour: '2', minute: '00' },
  { hour: '2', minute: '15' },
  { hour: '2', minute: '30' },
  { hour: '2', minute: '45' },
  { hour: '3', minute: '00' },
  { hour: '3', minute: '15' },
  { hour: '3', minute: '30' },
  { hour: '3', minute: '45' },
  { hour: '4', minute: '00' },
  { hour: '4', minute: '15' },
  { hour: '4', minute: '30' },
  { hour: '4', minute: '45' },
  { hour: '5', minute: '00' },
  { hour: '5', minute: '15' },
  { hour: '5', minute: '30' },
  { hour: '5', minute: '45' },
  { hour: '6', minute: '00' },
  { hour: '6', minute: '15' },
  { hour: '6', minute: '30' },
  { hour: '6', minute: '45' },
  { hour: '7', minute: '00' },
  { hour: '7', minute: '15' },
  { hour: '7', minute: '30' },
  { hour: '7', minute: '45' },
  { hour: '8', minute: '00' },
  { hour: '8', minute: '15' },
  { hour: '8', minute: '30' },
  { hour: '8', minute: '45' },
  { hour: '9', minute: '00' },
  { hour: '9', minute: '15' },
  { hour: '9', minute: '30' },
  { hour: '9', minute: '45' },
  { hour: '10', minute: '00' },
  { hour: '10', minute: '15' },
  { hour: '10', minute: '30' },
  { hour: '10', minute: '45' },
  { hour: '11', minute: '00' },
  { hour: '11', minute: '15' },
  { hour: '11', minute: '30' },
  { hour: '11', minute: '45' },
  { hour: '12', minute: '00' },
  { hour: '12', minute: '15' },
  { hour: '12', minute: '30' },
  { hour: '12', minute: '45' },
  { hour: '13', minute: '00' },
  { hour: '13', minute: '15' },
  { hour: '13', minute: '30' },
  { hour: '13', minute: '45' },
  { hour: '14', minute: '00' },
  { hour: '14', minute: '15' },
  { hour: '14', minute: '30' },
  { hour: '14', minute: '45' },
  { hour: '15', minute: '00' },
  { hour: '15', minute: '15' },
  { hour: '15', minute: '30' },
  { hour: '15', minute: '45' },
  { hour: '16', minute: '00' },
  { hour: '16', minute: '15' },
  { hour: '16', minute: '30' },
  { hour: '16', minute: '45' },
  { hour: '17', minute: '00' },
  { hour: '17', minute: '15' },
  { hour: '17', minute: '30' },
  { hour: '17', minute: '45' },
  { hour: '18', minute: '00' },
  { hour: '18', minute: '15' },
  { hour: '18', minute: '30' },
  { hour: '18', minute: '45' },
  { hour: '19', minute: '00' },
  { hour: '19', minute: '15' },
  { hour: '19', minute: '30' },
  { hour: '19', minute: '45' },
  { hour: '20', minute: '00' },
  { hour: '20', minute: '15' },
  { hour: '20', minute: '30' },
  { hour: '20', minute: '45' },
  { hour: '21', minute: '00' },
  { hour: '21', minute: '15' },
  { hour: '21', minute: '30' },
  { hour: '21', minute: '45' },
  { hour: '22', minute: '00' },
  { hour: '22', minute: '15' },
  { hour: '22', minute: '30' },
  { hour: '22', minute: '45' },
  { hour: '23', minute: '00' },
  { hour: '23', minute: '15' },
  { hour: '23', minute: '30' },
  { hour: '23', minute: '45' }
];
